<template>
    <transition name="fade">
        <div :class="['player', {'full-screen': inFullMode}]" name="ppPdfView" v-if="visible">
            <div id="PlayerContent" class="pdf-content" style="visibility:hidden">
                <canvas id="pdfCanvas"></canvas>
                <div class="toolbar" style="align-items: center;">
                    <button class="pdf-prev" type="button" @click.stop="goToPage(currentPage - 1)">
                        <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/image_svg.svg#Next"></use>
                        </svg>
                    </button>
                    <button class="pdf-next" type="button" @click.stop="goToPage(currentPage + 1)">
                        <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/image_svg.svg#Next"></use>
                        </svg>
                    </button>

                    <div class="progress-info">
                        <div class="progress-bar">
                            <div :style="{width: (progress*100).toFixed(2) + '%'}"></div>
                        </div>
                    </div>

                    <span class="pdf-number">{{currentPage}} / {{numPages}}</span>
                    <a class="pdf-next" style="display: flex; align-items: center;" :href="src" target="_blank">     <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/image_svg.svg#FillScr"></use>
                        </svg></a>
                    <button class="pdf-next" type="button" @click.stop="toggleFullScreen" v-if="!isMobile">
                   
                    </button>
                </div>
            </div>
        </div>
        <!--<div class="popup pdf" v-if="visible" name="ppPdfView">-->
            <!--<div :class="['popup-content', {'mobile': isMobile}]">-->
                <!--<div class="popup-close" @click="visible = false"></div>-->
                <!--<div class="popup-body">-->
                    <!--<div class="pdf-content">-->
                        <!--<transition name="pagefade" mode="out-in">-->
                            <!--<div class="pagefade" v-if="pageSwitch"></div>-->
                        <!--</transition>-->
                        <!--<canvas id="pdfCanvas"></canvas>-->
                    <!--</div>-->
                    <!--<div class="pdf-ctrl flex">-->
                        <!--<button class="pdf-prev margin-right-20" type="button" @click.stop="goToPage(currentPage - 1)">-->
                            <!--<svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
                                <!--<use xlink:href="/Content/dist/image_svg.svg#Next"></use>-->
                            <!--</svg>-->
                        <!--</button>-->
                        <!--<span class="pdf-number">{{currentPage}} / {{numPages}}</span>-->
                        <!--<button class="pdf-next margin-left-20" type="button" @click.stop="goToPage(currentPage + 1)">-->
                            <!--<svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
                                <!--<use xlink:href="/Content/dist/image_svg.svg#Next"></use>-->
                            <!--</svg>-->
                        <!--</button>-->
                    <!--</div>-->
                    <!---->
                    <!--<div class="pdf-close" @click.stop="visible = false"></div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    </transition>

</template>

<script>
    import pdfjs from 'pdfjs-dist/webpack'
    //pdfjs.GlobalWorkerOptions.workerSrc = "../../../node_modules/pdfjs-dist/build/pdf.worker.js";
    import UI from '../helpers/ui-helpers'

    export default {
        name: "pdf-viewer",

        props: ['title'],

        data(){
            return {
                src: null,
                pdfDoc: null,
                numPages: null,
                currentPage: null,
                visible: false,
                isMobile: UI.check_mobile(),
                pageSwitch: false,
                progress: 0,
                isRendering: false,
                maxPage: null,
                inFullMode: false
            }
        },

        watch: {
            currentPage(newVal){
                this.$emit('onPageChanged', newVal);

                this.progress = this.currentPage  / this.numPages;
            }
        },


        methods:{
            show(url, page, progressPage) {
                let vm = this;
                if(progressPage){
                    this.maxPage = progressPage;
                }

                vm.visible = true;
                vm.src = url;
                vm.loadPdf(page);
            },

            goToPage(page){
                if(page > 0 && page <= this.numPages){

                    this.renderPage(page);
                }
            },

            toggleFullScreen() {
                let vm = this;

                let req;
                if(vm.inFullMode ){
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) {
                        document.webkitExitFullscreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    let elem = document.getElementsByName("ppPdfView")[0];
                    req = elem.requestFullScreen || elem.webkitRequestFullScreen || elem.mozRequestFullScreen || elem.webkitEnterFullScreen;
                    req.call(elem);
                }
            },

            loadPdf(page){
                let vm = this;


                this.$nextTick(() => {
                    UI.blockUI('.material-body-content', null, {
                        overlayCSS:{
                            opacity: 1, backgroundColor: '#FFF!important'
                        }
                    });
                });

                    let loadingTask = pdfjs.getDocument(vm.src);
                    loadingTask.promise.then(function(pdf) {
                        //console.log('PDF loaded');
                        vm.pdfDoc = pdf;
                        vm.numPages = pdf.numPages;

                        // if (vm.maxPage && !isNaN(vm.maxPage)) {
                        //     vm.progress = parseInt(vm.maxPage) / vm.numPages;
                        // }

                        vm.renderPage(page || 1);
                        $('#PlayerContent').css('visibility', 'visible');
                        UI.unblockUI('.material-body-content');
                        
                    }, function (reason) {
                        // PDF loading error
                        //console.error(reason);
                        UI.unblockUI('.player');
                    });

            },

            renderPage(pageNumber){
                let vm = this;
                if(!vm.pdfDoc || vm.isRendering){
                    return;
                }

                vm.isRendering = true;
                vm.pdfDoc.getPage(pageNumber).then(function(page) {
                    //console.log('Page loaded');

                    let $popupBody = $('[name=ppPdfView]'); // контейнер для отображения пдф
                    let cWidth = $popupBody.width(),
                        cHeight = $popupBody.height();

                    let scale; // масштаб листа пдф, считаем в зависимости от ширины/высоты контейнера для отображения
                    scale = Math.min((cHeight-50) / (page.getViewport(1.0).height), cWidth / page.getViewport(1.0).width);

                    let viewport = page.getViewport({ scale: scale });
                    //console.log('viewport', viewport);
                    let canvas = document.getElementById('pdfCanvas');
                    let context = canvas.getContext('2d');

                    // console.info('[cWidth, cHeight]', [cWidth, cHeight]);
                    // console.info('[viewport.width, viewport.height]', [viewport.width, viewport.height]);

                    // задаём ширину и высоту самого канваса
                    canvas.height = viewport.height.toFixed(0);
                    canvas.width = viewport.width.toFixed(0);
                    $('#PlayerContent').width(viewport.width.toFixed(0) + 'px');
                    $('[name=ppPdfView] .toolbar').width(viewport.width.toFixed(0) + 'px');

                    let renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    let renderTask = page.render(renderContext);
                    renderTask.promise.then(function () {
                        //console.log('Page rendered');
                        vm.currentPage = pageNumber;
                        vm.isRendering = false;
                    });

                    vm.pageSwitch = true;
                    setTimeout(function(){
                        vm.pageSwitch = false;
                    }, 200);

                });
            },

            onkey(event){
                if(event.keyCode === 39){
                    this.goToPage(this.currentPage + 1);
                }
                else if(event.keyCode === 37){
                    this.goToPage(this.currentPage - 1);
                }else if(event.keyCode === 27){
                    //this.visible = false;
                }
            }
        },

        created(){
            let vm = this;

            window.addEventListener('keydown', this.onkey);
            document.addEventListener("fullscreenchange", function () {
                vm.inFullMode = document.fullscreen;
            }, false);
            document.addEventListener("mozfullscreenchange", function () {
                vm.inFullMode = document.mozFullScreen;
            }, false);
            document.addEventListener("webkitfullscreenchange", function () {
                vm.inFullMode = document.webkitIsFullScreen;
            }, false);
        },

        mounted () {
            let vm = this;

            $(window).on('resize orientationchange', function () {
                if(vm.visible) {
                    vm.$nextTick(() => {
                        vm.renderPage(vm.currentPage);
                    });
                }
            });
        },

        destroyed(){
            $(window).off('resize orientationchange');
            window.removeEventListener('keydown', this.onkey);
            this.pdfDoc = null;
        }
    }
</script>

<style>
    .pdf-content .toolbar{
        margin: 0 auto;
        display: flex;
    }
    .pdf-prev .svg-icon, .pdf-next .svg-icon{
        width:25px;
    }

    .player.full-screen{
        background: #fff;
    }
        .player.full-screen .pdf-content {
            margin: 0 auto;
            height: 100% !important;
        }

</style>


// WEBPACK FOOTER //
// Content/src/components/PdfViewer.vue